const hasOwnProperty = Object.prototype.hasOwnProperty
export const hasOwn = (obj, key) => {
  return hasOwnProperty.call(obj, key)
}

function extend(to, _from) {
  for (let key in _from) {
    to[key] = _from[key]
  }
  return to
};

export const toObject = (arr) => {
  var res = {}
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i])
    }
  }
  return res
}



// WEBPACK FOOTER //
// ./src/utils/index.js